// Copyright 2026 andrewzeck
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     https://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { msAPI } from "./index.js";
import moment from "moment";

export const getPlans = async () => {
  return (await msAPI.get("merchant/commissions")).data;
}
export const createPlan = async (data) => {
  return (await msAPI.post("merchant/commissions", data)).data;
}
export const updatePlan = async (planId, data) => {
  return (await msAPI.patch(`merchant/commissions/${planId}`, data)).data;
}
export const getActiveCommissions = async () => {
  return (await msAPI.get("merchant/commissions/active")).data;
}
export const getPastCommissions = async (date) => {
  if(!date) {
    date = moment().startOf("month").subtract(1, "month").startOf("day");
  }
  return (await msAPI.get("merchant/commissions/past", { params: { start: date.toDate() } })).data;
}
export const getCommissionForSeller = async (sellerId) => {
  return (await msAPI.get(`merchant/commissions/seller/${sellerId}`)).data;
}
export const applyCommissionToSeller = async (commissionPlanId, sellerId) => {
  return (await msAPI.post(`merchant/commissions/${commissionPlanId}/apply`, { seller_id: sellerId })).data;
}
export const deactivateCommissionForSeller = async (commissionPlanId, sellerId, expire = false) => {
  return (await msAPI.post(`merchant/commissions/${commissionPlanId}/deactivate`, { seller_id: sellerId, expire: expire })).data;
}